import { dataLayerPusher } from "@/web_analytics/dataLayer/dataLayerPusher/dataLayerPusher";

const ENTRY_SUBMIT_BUTTON_CLASS = "product-container-cta-button";
const ENTRY_SUBMIT_BUTTON_TEST_ID_SUFFIX = "-entry-submit-button";

const getElementTestId = (element: HTMLElement) => {
  return element.dataset.testid;
};

export const isShadowEntrySubmitButton = (
  element: EventTarget | null,
): element is HTMLButtonElement => {
  if (!(element instanceof HTMLButtonElement)) {
    return false;
  }

  const testId = getElementTestId(element);
  return (
    testId?.endsWith(ENTRY_SUBMIT_BUTTON_TEST_ID_SUFFIX) === true &&
    element.classList.contains(ENTRY_SUBMIT_BUTTON_CLASS)
  );
};

export const findShadowEntrySubmitButton = (event: Event) => {
  return event.composedPath().find(isShadowEntrySubmitButton) ?? null;
};

export const createShadowEntryClickStatus = (button: HTMLButtonElement) => {
  const buttonText = button.textContent?.trim().replaceAll(/\s+/gu, " ") ?? "";
  const testId = getElementTestId(button) ?? "";
  const className =
    typeof button.className === "string" ? button.className.trim() : "";

  return `|${buttonText}|${testId}|${className}`;
};

export const trackShadowEntryClick = (event: Event) => {
  const button = findShadowEntrySubmitButton(event);
  if (!button) {
    return;
  }

  dataLayerPusher.shadowDomEntryClick(
    button.tagName.toLowerCase(),
    createShadowEntryClickStatus(button),
  );
};
